import React from 'react';
import noop from 'lodash/noop';
import type { ProjectType } from '@jira/platform__project-types/src/project-types.tsx';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/jira-product-analytics-bridge';
import AsyncSoftDeleteProjectModal from '@atlassian/jira-project-soft-delete-modal/src/async.tsx';
import type { Props as AppProps } from '@atlassian/jira-project-soft-delete-modal/src/index.tsx';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import type { ModalProps } from '../../types.tsx';

export type SoftDeleteProjectModalOptions = {
	projectId: number;
	projectName: string;
	projectType: ProjectType;
	isProjectSimplified: boolean;
};

export type Props = AppProps & ModalProps;

const AsyncSoftDeleteProject = ({
	onClose,
	projectName,
	projectId,
	projectType,
	isProjectSimplified,
}: Props) => {
	const isAdmin = useIsAdmin();

	const onDeleteProjectSuccess = () => {
		onClose();
		if (isAdmin) {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.location.replace('/jira/settings/projects/manage');
		} else {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.location.replace('/jira/projects');
		}
	};

	return (
		<ContextualAnalyticsData sourceName="EditProjectDetails" sourceType={SCREEN}>
			<AsyncSoftDeleteProjectModal
				onClose={onClose}
				projectName={projectName}
				projectType={projectType}
				projectId={projectId}
				isProjectSimplified={isProjectSimplified}
				onDeleteProjectSuccess={onDeleteProjectSuccess}
				onDeleteProjectFailure={noop}
				onDeleteSuccessFlagRestore={undefined}
			/>
		</ContextualAnalyticsData>
	);
};

export default AsyncSoftDeleteProject;
